// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"673":"7e480f07","3171":"c843c519","7562":"d8d2097e","8120":"e872979c"}[chunkId] + ".chunk.css";
};